import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingService } from '@services/loading/loading.service';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  public forgotPasswordForm: FormGroup;
  public isAuthLoading = false;
  public env = environment.forntend_url;
  public submitted: boolean = false;


  constructor(public formBuilder: FormBuilder, public router: Router, public loader: LoadingService) { }

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required]],
    });
  }

  ngOnDestroy(): void { }

  get formData() {
    return this.forgotPasswordForm.controls;
  }

  /**
   * @name submit
   * @description This method is used to verify email for recover password
   * @param none
   * @return none
   */

  submit() {
    this.submitted = true;
    this.router.navigate(['/recover-password']);
  }
}
